export default __webpack_public_path__ + "locales/fr/Translations.json?hash=2e7d41955cc1f5bad817dd7cbf656b29";